export default __webpack_public_path__ + "static/media/avatar20-dog.b3cd2acc.png";